/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbDirectionTerritorialeGridDto } from './FcbDirectionTerritorialeGridDto';
import {
    FcbDirectionTerritorialeGridDtoFromJSON,
    FcbDirectionTerritorialeGridDtoFromJSONTyped,
    FcbDirectionTerritorialeGridDtoToJSON,
} from './FcbDirectionTerritorialeGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbDirectionTerritorialeGridDtoPaginatedResults
 */
export interface FcbDirectionTerritorialeGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbDirectionTerritorialeGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbDirectionTerritorialeGridDto>}
     * @memberof FcbDirectionTerritorialeGridDtoPaginatedResults
     */
    results?: Array<FcbDirectionTerritorialeGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbDirectionTerritorialeGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbDirectionTerritorialeGridDtoPaginatedResults interface.
 */
export function instanceOfFcbDirectionTerritorialeGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbDirectionTerritorialeGridDtoPaginatedResultsFromJSON(json: any): FcbDirectionTerritorialeGridDtoPaginatedResults {
    return FcbDirectionTerritorialeGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbDirectionTerritorialeGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbDirectionTerritorialeGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbDirectionTerritorialeGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbDirectionTerritorialeGridDtoPaginatedResultsToJSON(value?: FcbDirectionTerritorialeGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbDirectionTerritorialeGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

